import { createAsyncStoragePersister } from '@tanstack/query-async-storage-persister';
import { type OmitKeyof, QueryClient } from '@tanstack/react-query';
import { type PersistQueryClientOptions, PersistQueryClientProvider } from '@tanstack/react-query-persist-client';
import { dateAwareDataDeserializer } from './utils/dateAwareDataDeserializer';

const queryClient = new QueryClient({
  defaultOptions: {
    queries: { queryFn: () => Promise.resolve() },
  },
});

const persistOptions: OmitKeyof<PersistQueryClientOptions, 'queryClient'> = {
  persister: createAsyncStoragePersister({ storage: window.localStorage }),
  maxAge: Infinity,
  hydrateOptions: {
    defaultOptions: {
      deserializeData: dateAwareDataDeserializer,
      queries: {
        gcTime: Infinity,
      },
    },
  },
  dehydrateOptions: {
    shouldDehydrateQuery: (query) => !!query.meta?.shouldPersist && !!query.state.dataUpdateCount,
  },
};

export default function QueryClientProvider({ children }: { children: React.ReactNode }) {
  return (
    <PersistQueryClientProvider client={queryClient} persistOptions={persistOptions}>
      {children}
    </PersistQueryClientProvider>
  );
}
